
import './App.css';

function Video(props) {
const video = props.vids;
console.log("vid");
  return (
    <div >
    {
      video.map(vid => <div >

        <video width="320" height="240" controls>
        <source src={vid} type="video/mp4"></source>
        </video>
    </div>
    )
    }
    </div>
  );
}

export default Video;
